import React from 'react';
import PropTypes from 'prop-types';
import DateTimePickerDropdown from 'components/common-components/DateTimePickerDropdown';
import TimeWithUnitField from './TimeWithUnitField';
import { timeUnitOptionsList } from '../../../utils';
import { useTranslation } from 'react-i18next';

const OneTimeSchedule = ({ values, handleChange }) => {
  const { t } = useTranslation();
  return (
    <div className='w-100 p-3 d-flex flex-column gap-3'>
      <div className='row align-items-center'>
        <div className='col-5 d-flex flex-column'>
          <span className='theme-font-inter-semi-bold theme-text-black-1'>
            {t('field_starts_at')}
          </span>
        </div>
        <div className='col-7'>
          <DateTimePickerDropdown
            name='startDate'
            value={values.startDate}
            onChange={handleChange}
            format12Hour
            defaultTime='startOfDay'
          />
        </div>
      </div>

      <div className='row align-items-center'>
        <div className='col-5 d-flex flex-column'>
          <span className='theme-font-inter-semi-bold theme-text-black-1'>
            {t('field_ends_at')}
          </span>
        </div>
        <div className='col-7'>
          <DateTimePickerDropdown
            name='endDate'
            value={values.endDate}
            onChange={handleChange}
            format12Hour
            defaultTime='startOfDay'
          />
        </div>
      </div>

      {/* Review Period */}
      <div className='row align-items-center'>
        <span className='col-5 theme-font-inter-semi-bold theme-text-black-1'>
          {t('text_review_period')}
        </span>
        <div className='col-7'>
          <TimeWithUnitField
            timeName='reviewPeriodTime'
            unitName='reviewPeriodFormat'
            timeValue={values.reviewPeriodTime}
            unitValue={values.reviewPeriodFormat}
            unitOptions={timeUnitOptionsList}
            handleChange={handleChange}
          />
        </div>
      </div>
    </div>
  );
};

OneTimeSchedule.propTypes = {
  values: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default React.memo(OneTimeSchedule);
